import moment from 'moment'

export const EXCEL_DATE_COLUMNS = [
  'createdAt',
  'completedAt',
  'executedAt',
  'impactStartDate',
  'impactEndDate',
  'financialValidationDate',
]

export const EXCEL_LOCAL_DATE_NUMBER_FORMAT = 'yyyy-mm-dd'

const DATE_ACCESSORS = {
  createdAt: item => item?.createdAt,
  completedAt: item => item?.completedAt,
  executedAt: item => item?.createdAt,
  impactStartDate: item => item?.impactStartsAt,
  impactEndDate: item => item?.impactEndsAt,
  financialValidationDate: item => item?.validations?.financial?.validatedAt,
}

export function isExcelDateColumn(column) {
  return EXCEL_DATE_COLUMNS.includes(column)
}

export function toExcelDateValue(unformattedDate) {
  return toExcelDateSerial(unformattedDate)
}

export function toExcelDateSerial(unformattedDate) {
  if (!unformattedDate) return ''

  if (typeof unformattedDate === 'string') {
    const isoDate = moment.utc(unformattedDate, moment.ISO_8601, true)

    if (isoDate.isValid()) {
      return toUtcExcelDateSerial(isoDate)
    }

    const parsedDate = moment(unformattedDate, 'DD/MM/YYYY', true)

    if (parsedDate.isValid()) {
      return toUtcExcelDateSerial(parsedDate)
    }

    return ''
  }

  const date = moment.utc(unformattedDate)

  if (date.isValid()) {
    return toUtcExcelDateSerial(date)
  }

  return ''
}

function toUtcExcelDateSerial(date) {
  return moment.utc([
    date.year(),
    date.month(),
    date.date(),
  ]).diff(moment.utc('1899-12-30'), 'days')
}

export function getExcelDateValue(item, column) {
  if (!isExcelDateColumn(column)) return null

  const rawValue = DATE_ACCESSORS[column]?.(item)

  return toExcelDateValue(rawValue)
}

export function buildExcelDateNumberFormats(
  columns,
  rowCount,
  includeHeaderRow = false
) {
  const dataRowFormat = columns.map(column =>
    isExcelDateColumn(column) ? EXCEL_LOCAL_DATE_NUMBER_FORMAT : null
  )

  const dataRowFormats = Array.from({ length: rowCount }, () => [...dataRowFormat])

  if (!includeHeaderRow) {
    return dataRowFormats
  }

  return [columns.map(() => null), ...dataRowFormats]
}

export function buildExcelTableName(name) {
  const sanitizedName = String(name)
    .replace(/\W/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '')

  if (!sanitizedName) {
    return 'ImportedTable'
  }

  if (/^[A-Za-z_]/.test(sanitizedName)) {
    return `${sanitizedName}Table`
  }

  return `Table_${sanitizedName}`
}

export function buildExcelTableWritePlan({
  rowCursor,
  rowCount,
  isNewEntityWorksheet,
}) {
  const startRow = rowCursor + 1
  const endRow = rowCursor + rowCount + (isNewEntityWorksheet ? 1 : 0)

  return {
    mode: isNewEntityWorksheet ? 'create_table' : 'append_rows',
    startRow,
    endRow,
    newRowCursor: endRow,
  }
}

export default {
  buildExcelDateNumberFormats,
  buildExcelTableName,
  buildExcelTableWritePlan,
  EXCEL_DATE_COLUMNS,
  EXCEL_LOCAL_DATE_NUMBER_FORMAT,
  getExcelDateValue,
  isExcelDateColumn,
  toExcelDateSerial,
  toExcelDateValue,
}
